<footer *ngIf="!onRegisterPage" [ngStyle]="{'background-color': bgColor}">

    <!-- Section: Links  -->
    <section class="">
      <div class="container text-center text-md-start mt-2 p-1">
        <!-- Grid row -->
        <div class="row mt-3">
          <!-- Grid column -->
          <div class="col-md-3 col-lg-4 col-xl-3 mx-auto">
            <!-- Content -->
            <h6 class="text-uppercase fw-bold mb-4">
              <fa-icon class="me-2 mb-0" [icon]="faGem"></fa-icon>Hotedrsica.si
            </h6>
            <p>
                Odkrij Hotedršico.
            </p>
            <p>
              Najlepša vas na Notranjskem.
            </p>
          </div>
          <!-- Grid column -->
  
          <!-- Grid column -->
          <div class="col-md-2 col-lg-2 col-xl-2 mx-auto">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">
              Povezave
            </h6>
            <p>
              <a routerLink="{{homeRoute}}" class="text-reset">Domov</a>
            </p>
            <p>
              <a routerLink="{{calendarRoute}}" class="text-reset">Koledar</a>
            </p>
            <p>
              <a routerLink="{{marketRoute}}" class="text-reset">Tržnica</a>
            </p>
            <p>
              <a routerLink="{{registerRoute}}" class="text-reset">Prijava</a>
            </p>
          </div>
          <!-- Grid column -->
          <div class="col-md-2 col-lg-2 col-xl-2 mx-auto">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">
              Organizacije
            </h6>
              <div class="col-auto" *ngFor="let org of organisations.slice(1); let i = index">
              <a class="text-reset" [routerLink]="['/organisation', org.slug]">
                {{ org.name }}
              </a>          
            </div>
          </div>
          <!-- Grid column -->
  
          <!-- Grid column -->
          <div *ngIf="currentOrganisation" class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">
              Kontakt
            </h6>
          
            <!-- Conditionally display content based on current organisation -->
            <p *ngIf="currentOrganisation">
              <fa-icon class="me-2 mb-0" [icon]="faHome"></fa-icon>
              {{ currentOrganisation.address || 'No address available' }}
            </p>
            <p *ngIf="currentOrganisation">
              <fa-icon class="me-2 mb-0" [icon]="faEnvelope"></fa-icon>
              {{ currentOrganisation.email || 'No email available' }}
            </p>
            <p *ngIf="currentOrganisation">
              <fa-icon class="me-2 mb-0" [icon]="faPhone"></fa-icon>
              {{ currentOrganisation.phone || 'No phone available' }}
            </p>
            <div *ngIf="currentOrganisation && currentOrganisation.type">
              <div class="social-links-container" style="display: flex; gap: 10px; align-items: center;">
                <!-- Facebook Link -->
                <a *ngIf="currentOrganisation.type" [href]="currentOrganisation.type" target="_blank" class="footer-facebook-link">
                  <fa-icon style="color: white;" [icon]="faFacebook"></fa-icon>
                </a>
            
                <!-- Instagram Link for specific organisation -->
                <div *ngIf="currentOrganisation.organisationID === 2">
                  <a href="https://www.instagram.com/sd.hotedrsica/" target="_blank" class="footer-instagram-link">
                    <fa-icon style="color: white;" [icon]="faInstagram"></fa-icon>
                  </a>
                </div>
              </div>
            </div>
            
            
          </div>
          <div *ngIf="!currentOrganisation" class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0">
            <p>
              Spletna stran je diplomsko delo Maksa Požarnika Vavkna, člana ŠD Hotedršica.
            </p>
          </div>
          
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </div>
    </section>
    <!-- Section: Links  -->
  
    <!-- Copyright -->
    <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05);">
      © 2024 Avtorske pravice:
      <a class="text-reset fw-bold">Maks Požarnik Vavken</a>
    </div>
    <!-- Copyright -->
  </footer>
  <!-- Footer -->